/**
 |--------------------------------------------------------------------------
 | NEWS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
 const news = [
  {
   path: '/news/all', component: require('pages/news/all.vue').default,
   name: 'all_news',
   meta: {requiresAuth: true, title: "All News Articles", icon: "fas fa-newspaper"}
  }, {
   path: '/news/create', component: require('pages/news/create.vue').default,
   name: 'create_news',
   meta: {requiresAuth: true, title: "Create News Article", icon: "fas fa-pen-square"}
  }, {
     path: '/news/edit', component: require('pages/news/edit.vue').default,
     name: 'edit_news',
     meta: {requiresAuth: true, title: "Edit News Article", icon: "fas fa-pen-square"}
  }, {
     path: '/news/view', component: require('pages/news/view.vue').default,
     name: 'view_news',
     meta: {requiresAuth: true, title: "View News Article", icon: "fas fa-eye"}
   },
 ];
 export default news;
 